import { PRESS_REVIEW, fetchByCategory } from "../utils.api";

//get press review writing
export const reviewApi = async () => {
  const reviewData = await fetchByCategory(PRESS_REVIEW);

  return reviewData;
};
